import React, { useState, useEffect } from "react";
import { Button, Modal, Table, Form, Spinner } from "react-bootstrap";
import { AiFillDelete } from "react-icons/ai";
import axios from "axios";

const BASE_URL = "https://dailydish.in/api";

const KarleMenuTab = () => {
  const [menu, setMenu] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [showAdd, setShowAdd] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [search, setSearch] = useState("");

  const [showDelete, setShowDelete] = useState(false);
  const [delData, setDelData] = useState(null);

  const getMenu = async () => {
    try {
      setIsDataLoading(true);
      const res = await axios.get(`${BASE_URL}/karle/menu/getMenu`);
      if (res.data.success) setMenu(res.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDataLoading(false);
    }
  };

  const getAllProducts = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/karle/products/getProducts`);
      if (res.data.success) setAllProducts(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getMenu();
    getAllProducts();
  }, []);

  const menuProductIds = new Set(
    menu.map((m) =>
      typeof m.karleProductId === "object"
        ? m.karleProductId?._id
        : m.karleProductId,
    ),
  );
  const availableProducts = allProducts.filter(
    (p) => !menuProductIds.has(p._id),
  );
  const filteredAvailable = availableProducts.filter((p) =>
    p.foodName?.toLowerCase().includes(search.toLowerCase()),
  );

  const handleShowAdd = () => {
    setSelectedProductId("");
    setSearch("");
    setShowAdd(true);
  };
  const handleCloseAdd = () => setShowAdd(false);

  const addToMenu = async () => {
    try {
      if (!selectedProductId) return alert("Please select a product");
      setIsLoading(true);
      const res = await axios.post(`${BASE_URL}/karle/menu/addToMenu`, {
        karleProductId: selectedProductId,
        priority: menu.length,
      });
      if (res.status === 200) {
        alert("Added to menu");
        handleCloseAdd();
        await getMenu();
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || "Error adding to menu");
    } finally {
      setIsLoading(false);
    }
  };

  const toggleActive = async (item) => {
    try {
      setIsLoading(true);
      await axios.put(`${BASE_URL}/karle/menu/updateMenuItem/${item._id}`, {
        isActive: !item.isActive,
      });
      await getMenu();
    } catch (error) {
      console.error(error);
      alert("Error updating menu entry");
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowDelete = (item) => {
    setDelData(item);
    setShowDelete(true);
  };
  const handleCloseDelete = () => setShowDelete(false);

  const removeFromMenu = async () => {
    try {
      setIsLoading(true);
      const res = await axios.delete(
        `${BASE_URL}/karle/menu/removeFromMenu/${delData._id}`,
      );
      if (res.status === 200) {
        alert("Removed from menu");
        handleCloseDelete();
        await getMenu();
      }
    } catch (error) {
      console.error(error);
      alert("Error removing from menu");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="customerhead p-2">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <p style={{ margin: 0 }}>
            This menu repeats every day as-is until you add, remove, or edit an
            item.
          </p>
          <Button variant="success" onClick={handleShowAdd}>
            + Add to Menu
          </Button>
        </div>

        {isDataLoading ? (
          <div className="text-center my-5">
            <Spinner animation="border" variant="oranged" />
            <p>Loading menu...</p>
          </div>
        ) : (
          <Table
            responsive
            bordered
            style={{ width: "-webkit-fill-available" }}
          >
            <thead>
              <tr>
                <th>Sl. No</th>
                <th>Image</th>
                <th>Food Name</th>
                <th>Karle Price</th>
                <th>Short Description</th>
                <th>Active</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {menu.map((item, i) => {
                const product = item.karleProductId || {};
                return (
                  <tr key={item._id}>
                    <td>{i + 1}</td>
                    <td>
                      <img
                        src={product.foodImage}
                        alt="img"
                        style={{ width: "60px", height: "60px" }}
                      />
                    </td>
                    <td>{product.foodName}</td>
                    <td>{product.karlePrice}</td>
                    <td>{product.shortDescription}</td>
                    <td>
                      <Form.Check
                        type="switch"
                        checked={item.isActive}
                        onChange={() => toggleActive(item)}
                        disabled={isLoading}
                      />
                    </td>
                    <td>
                      <AiFillDelete
                        className="text-danger"
                        style={{ cursor: "pointer", fontSize: "20px" }}
                        onClick={() => handleShowDelete(item)}
                      />
                    </td>
                  </tr>
                );
              })}
              {menu.length === 0 && (
                <tr>
                  <td colSpan={7}>No items on the menu yet</td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>

      {/* Add to menu modal */}
      <Modal show={showAdd} onHide={handleCloseAdd} style={{ zIndex: "99999" }}>
        <Modal.Header closeButton>
          <Modal.Title>Add Product to Menu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control mb-2"
            placeholder="Search Karle products..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div style={{ maxHeight: 260, overflowY: "auto" }}>
            {filteredAvailable.length === 0 ? (
              <p style={{ color: "#aaa" }}>No available products found</p>
            ) : (
              filteredAvailable.map((p) => (
                <div
                  key={p._id}
                  onClick={() => setSelectedProductId(p._id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "8px 10px",
                    cursor: "pointer",
                    borderRadius: 6,
                    background:
                      selectedProductId === p._id ? "#e8f4d4" : "transparent",
                    border: "1px solid #eee",
                    marginBottom: 6,
                  }}
                >
                  <img
                    src={p.foodImage}
                    alt=""
                    style={{ width: 40, height: 40, borderRadius: 4 }}
                  />
                  <div>
                    <div style={{ fontWeight: 500 }}>{p.foodName}</div>
                    <div style={{ fontSize: 12, color: "#888" }}>
                      ₹{p.karlePrice}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-close-btn"
            variant=""
            onClick={handleCloseAdd}
            disabled={isLoading}
          >
            Close
          </Button>
          <Button
            className="modal-add-btn"
            variant=""
            onClick={addToMenu}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="ms-2">Adding...</span>
              </>
            ) : (
              "Add"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Remove confirm modal */}
      <Modal
        show={showDelete}
        onHide={handleCloseDelete}
        style={{ zIndex: "99999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-4" style={{ color: "red" }}>
            Remove "{delData?.karleProductId?.foodName}" from the menu?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-close-btn"
            variant=""
            onClick={handleCloseDelete}
            disabled={isLoading}
          >
            Close
          </Button>
          <Button
            className="modal-add-btn"
            variant=""
            onClick={removeFromMenu}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="ms-2">Removing...</span>
              </>
            ) : (
              "Remove"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default KarleMenuTab;
